import type {
	AppState,
	NubeSDKState,
} from "@tiendanube/nube-sdk-internal-types";
import { importApp } from "./code-handler";
import { dispatchError } from "./messages";
import { withPerformanceMonitor } from "./telemetry";
import { createWorkerSDK } from "./worker/sdk";

export async function run(
	app: Pick<AppState, "id" | "script" | "appSettings">,
	initialState: NubeSDKState,
) {
	const storeId = self.__INITIAL_STATE__?.store?.id ?? 0;
	const storeName = self.__INITIAL_STATE__?.store?.name ?? "unknown";
	const storeDomain = self.__INITIAL_STATE__?.store?.domain ?? "unknown";
	const workerSDK = createWorkerSDK(
		initialState,
		app.id,
		app.script,
		storeId,
		storeName,
		storeDomain,
		undefined,
		app.appSettings,
	);
	await importApp(app)
		.then((partner) => {
			if (typeof partner.App !== "function") {
				dispatchError(app.id, "Partner App entrypoint is not a function");
				return;
			}

			const monitoredApp = withPerformanceMonitor(
				partner.App,
				app.id,
				app.script,
				storeId,
				storeName,
				storeDomain,
			);

			return monitoredApp(workerSDK);
		})
		.catch((error) => {
			dispatchError(
				app.id,
				error instanceof Error
					? error.message
					: typeof error === "string"
						? error
						: `unable to register app ${error}`,
			);
		});
}
